module.exports = __webpack_public_path__ + "img/conclusion.81aeab4e.png";